import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useAppointmentDetailsModel } from "./appointmentDetailsModels";
import { RouterParamType } from "@/model/navModel";
import { DetailType } from "@/types/ScmEnums";
import { IItemDetailList } from "../../appointmentType";
import { bigNumber, formatIntPoint, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import FontIcon from "@/components/YhIcon";
import { useVrmModel } from "@/model/vrmModel"
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

export const ItemTableBox: FC<RouterParamType> = ({ id, mode, IFormRef, parentInfo }) => {
    const { temporaryObj, setTemporaryid } = useVrmModel()
    const {
        setItemModel,
        detailEditForm,
        detailItemAddList, setDetailItemAddList,
        detailItemAddDataRowKeys, setDetailItemAddDataRowKeys,
        setDetailItemAddDataRow,
        detailItemEditList, setDetailItemEditList,
        detailItemEditDataRowKeys, setDetailItemEditDataRowKeys,
        setDetailItemEditDataRow,
        detailItemLookList,
        detailItemDetailList,
    } = useAppointmentDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const onTemporary = () => {
        setTemporaryid(new Date().getTime().toString())
        mode === "add" ? setDetailItemAddList([...detailItemAddList, temporaryObj]) : setDetailItemEditList([...detailItemEditList, temporaryObj])
    }
    const title = <>
        <span>维修项目</span>
        {/* <Tooltip placement="topLeft" title="新增临时项目">
            <FontIcon type="icon-linshibiaoge" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={() => onTemporary()}
            />
        </Tooltip> */}
    </>
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && detailEditForm.status === DictCodeEnmu.APPOINTMENT_TRANSFER || detailEditForm.status === DictCodeEnmu.APPOINTMENT_CHANGE) {
            return false;
        }
        return true;
    }
    const action = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.AP_ED_ADD_I}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => {
                        IFormRef.current?.validateFields().then(async () => {
                            setItemModel(true)
                        })
                    }}
                >新增项目</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.AP_ED_DEL_I}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => detailItemDetailList(mode, parentInfo)}
                >删除项目</Button>
            </YhAuth>
        </>}
    </>;

    const typeItemList = {
        "add": [...detailItemAddList],
        "edit": [...detailItemEditList],
        "look": [...detailItemLookList],
    }

    const itemColumn = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '项目编码',
            width: 120,
            dataIndex: 'itemCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '项目名称',
            width: 160,
            dataIndex: 'itemName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '工时',
            width: 100,
            dataIndex: 'workHour',
            editable: isMaterialModel(),
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: isMaterialModel(),
        }, {
            title: '工时费',
            width: 100,
            dataIndex: 'itemAmount',
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            editable: isMaterialModel(),
            render: (text: string) => text + "%"
        }, {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: isMaterialModel(),
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => {
                isMaterialModel() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeItem(record)}
                />
            }
        }
    ];

    const removeItem = (record: IItemDetailList) => {
        detailItemDetailList(mode, parentInfo, record)
    }
    const newSelectItemColums = () =>
        itemColumn.map((col: any, index) => {
            let disaBled = col.dataIndex === "itemCode" || col.dataIndex === "itemName"

            return {
                ...col,
                onCell: (record: IItemDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: disaBled ? record.temporary && mode !== "look" : col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    // allowClear: col.allowClear,
                    mode: col.mode,
                    handleSave: handleItemSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "appointment", "roleCodes": roles };
        return getRoleColumns("appointment", "维修项目", newSelectItemColums(), params);
    }, [roles, typeItemList[mode], itemColumn]);
    const handleItemSave = (row: IItemDetailList) => {
        let { workHour, price, discountRate, itemAmount, receivableAmount } = row
        workHour = +formatNum(workHour); //工时
        price = +formatNum(price); //工时费
        discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        let newRow = {
            ...row,
            price,
            workHour,
            discountRate,
            // itemAmount: +formatNum(workHour * price),
            // receivableAmount: +formatNum((workHour * price * discountRate) / 100),
            itemAmount: +formatNum(bigNumber.multiTimes(workHour, price)),
            receivableAmount: +formatNum(bigNumber.multiTimes(workHour, price, discountRate) / 100)
        }
        let newData = mode === "edit" ? detailItemEditList : detailItemAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailItemEditList([...newData]) : setDetailItemAddList([...newData])
    }
    //设置维修项目选中的行和数据
    const setTypeItemDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeItemDetailDataRow = async (selectedRows: IItemDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRow(selectedRows)
        }
    }


    return (
        <YhBox title={title} rightChildren={action} style={{ marginBottom: "5px" }}>
            <Table
                style={{ marginBottom: '10px' }}
                bordered
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailItemAddDataRowKeys : detailItemEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IItemDetailList[]) => {
                            setTypeItemDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeItemDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeItemDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeItemList[mode] as IItemDetailList[]}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}